import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDatas(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .get('metadata/householdequipments', {
            params: userData
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchData(ctx, {
      id
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`metadata/householdequipments/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addData(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('metadata/householdequipments', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    editData(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`metadata/householdequipments/${userData.id}`,
            userData
          )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteData(ctx, {
      id
    }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`metadata/householdequipments/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    downloadDocument(ctx, {
      id
    }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`v1/app/documents/download/${id}`, {
            responseType: 'blob'
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteDocument(ctx, {
      id
    }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`v1/app/documents/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAdminDatas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/all/pricing')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchfamilymember(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/all/familymemberdetails')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}